import React, { useState } from 'react';
import { CardMedia } from '@mui/material';
import { styles } from './styles';
import { Box } from '@mui/material';
import { Button } from 'gatsby-material-ui-components';
import PlayIcon from '../VideoBlock/icons/PlayIcon';
import { StaticImage } from 'gatsby-plugin-image';

export default function ShortsVideo({ video, children }) {
  const [isOpen, setIsOpen] = useState(false);

  return isOpen ? (
    <CardMedia
      onClick={() => setIsOpen(false)}
      src={`https://www.youtube.com/embed/${video}?embed=true&autoplay=1`}
      component="iframe"
      allowFullScreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      frameBorder="0"
      title="Embedded youtube shorts"
      sx={styles.previewWrapper}
    />
  ) : (
    <Box sx={styles.previewWrapper}>
      {children || <StaticImage src="./images/preview.jpg" alt="preview" />}
      <Button sx={styles.videoButton} onClick={() => setIsOpen(true)}>
        <Box sx={styles.iconWrapper}>
          <PlayIcon />
        </Box>
      </Button>
    </Box>
  );
}
